module.exports = __webpack_public_path__ + "static/assets/a245d2d4fd14ceef657b71e1c341d29c.jpg";